import React, { useState, useEffect } from "react";
import {
  getDealerWarrantyList,
  updateDealerWarranty,
} from "../../../services/apiService";

const ApprovedWarrantyList = () => {
  const [pendingWarrantyData, setPendingWarrantyData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const fetchWarrantyList = async () => {
    try {
      setLoading(true);
      const response = await getDealerWarrantyList();
      const data = response?.data || response?.Data || [];
      const approvedData = data.filter(
        (item) => String(item.isapproved).trim() === "1"
      );
      console.log("Approved Data:", approvedData);
      setPendingWarrantyData(approvedData);
      setCurrentPage(1); // Reset to first page on data fetch
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWarrantyList();
  }, []);

  // Filter based on search input
  const filtered = pendingWarrantyData.filter((item) => {
    return (
      item.orderno?.toLowerCase().includes(search.toLowerCase()) ||
      item.modelno?.toLowerCase().includes(search.toLowerCase()) ||
      item.scratchno?.toLowerCase().includes(search.toLowerCase()) ||
      item.dealername?.toLowerCase().includes(search.toLowerCase())
    );
  });

  // Calculate total pages
  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  // Slice data for current page
  const paginatedData = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ marginBottom: "15px" }}>Approved Warranty List</h2>

      <input
        type="text"
        placeholder="Search Warranty ID, Customer, Product..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setCurrentPage(1); // Reset to first page on search
        }}
        style={{
          width: "320px",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          marginBottom: "20px",
        }}
      />

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#d3d7dc" }}>
            <th style={th}>Invoice No</th>
            <th style={th}>Customer</th>
            <th style={th}>Dealer</th>
            <th style={th}>Product</th>
            <th style={th}>Stratch No</th>
            <th style={th}>Purchase Date</th>
            <th style={th}>Approved Date</th>
            <th style={th}>Status</th>
            <th style={th}>Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((row, index) => (
              <tr key={row.id || index}>
                <td>{row.orderno}</td>
                <td style={td}>{row.first_name}</td>
                <td>{row.dealername}</td>
                <td>{row.modelno}</td>
                <td>{row.scratchno}</td>
                <td>{new Date(row.startdate).toLocaleDateString()}</td>
                <td>{new Date(row.enddate).toLocaleDateString()}</td>
                <td>
                  <span
                    style={{
                      backgroundColor: "#28a745",
                      color: "#fff",
                      padding: "5px 12px",
                      borderRadius: "20px",
                    }}
                  >
                    Approved
                  </span>
                </td>
                <td>
                  <button
                    style={{
                      background: "#005487",
                      color: "#fff",
                      border: "none",
                      padding: "8px 18px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" align="center">
                No approved warranty records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div
        style={{
          marginTop: "25px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <strong>Items per page:</strong>
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value));
              setCurrentPage(1);
            }}
            style={{
              marginLeft: "10px",
              padding: "5px",
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
          </select>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{
              padding: "6px 12px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
            }}
          >
            Previous
          </button>
          <strong>
            {currentPage} / {totalPages}
          </strong>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              padding: "6px 12px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
            }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

const th = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "left",
  fontWeight: "bold",
};

const td = {
  border: "1px solid #ddd",
  padding: "10px",
};

export default ApprovedWarrantyList; 